<template>
  <v-container fluid fill-height class="pa-0">
    <v-layout class="pa-0" row>
      <gmap-map
        class="AppMap__map"
        :center="center"
        :zoom="7"
        ref="createFenceMap"
        :options="mapOptions"
      >
        <GmapPolygon
          v-if="newPath.length!==0"
          :path="newPath"
          editable
          @path_changed="newPathChanged"
        />
      </gmap-map>
      <v-flex style="width:400px;height: 100%;">
        <v-card>
          <v-toolbar color="primary darken-2" dark dense>
            <v-toolbar-title class="text-xs-center">Nueva cerca</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout column>
              <v-flex>
                <v-text-field
                  name="name"
                  label="Nombre"
                  id="name"
                  v-model="newName"
                />
              </v-flex>
              <v-flex class="d-inline-flex" style="justify-items: center">
                <v-btn color="primary" :loading="loadingDone" @click="handleDoneClick">Aceptar</v-btn>
                <v-btn color="error" @click="cancel">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import mapOptions from '../../utils/mapOptions'
  import {mapActions} from 'vuex'
  import {loaded} from 'vue2-google-maps'

  /**
   * Componente que crea una Geocerca
   * @author Manuel Ochoa
   */
  export default {
    name: 'create-geofence-view',
    data() {
      return {
        center: {
          lat: 6.254790211409118,
          lng: -75.551029793457
        },
        mapOptions,
        /**
         * Array de posiciones que describe un poligono en Google Maps
         * @type {array}
         */
        newPath: [],
        /**
         * Variable que almacena el nombre de la geocerca
         * @type {string}
         */
        newName: '',
        /**
         * Controla la visibilidad del estado de carga para la creación de la Geocerca
         * @type {boolean}
         */
        loadingDone: false,
        mapClickListener: null
      }
    },
    methods: {
      newPathChanged(mvcPath) {
        // `path_changed` entrega un MVCArray de google.maps.LatLng.
        this.newPath = mvcPath.getArray()
      },
      cancel() {
        this.newPath = []
        this.$router.back()
      },
      /**
       * Metodo que crea la GeoCerca con una llamada al action `createGeofence()`
       */
      handleDoneClick() {
        this.loadingDone = true
        this.createGeofence({name: this.newName, path: this.newPath})
          .then(fence => {
            this.loadingDone = false
            this.$router.back()
          })
      },
      ...mapActions(['createGeofence'])
    },
    /**
     * Metodo de inicialización, el cual espera que Google Maps este disponible.
     *
     * `DrawingManager` fue removido de la Maps JS API en la v3.65
     * (https://developers.google.com/maps/deprecations). En su lugar el
     * polígono se dibuja manualmente: cada click en el mapa agrega un vértice
     * a `newPath`, que renderiza el <GmapPolygon> editable de la plantilla.
     */
    mounted() {
      loaded.then(() => {
        const mapObject = this.$refs.createFenceMap.$mapObject
        // Se reasigna el array (no push) para que el watcher de `path`
        // (deep: false) de vue2-google-maps detecte el cambio y redibuje.
        this.mapClickListener = mapObject.addListener('click', (event) => {
          this.newPath = [...this.newPath, event.latLng]
        })
      })
    },
    beforeDestroy() {
      if (this.mapClickListener) {
        google.maps.event.removeListener(this.mapClickListener)
        this.mapClickListener = null
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Geofence/CreateGeofenceView.vue